import isObject from 'lodash/fp/isObject';
export const hasKeys = (keys) => keys && Object.keys(keys).length > 0;

export const hasValues = (values) =>
  values && Object.values(values).some((e) => e);

export const fillObject = (object, value) => {
  return Object.keys(object).reduce(
    (acc, current) => ({ ...acc, [current]: value }),
    {}
  );
};

export const isSameArray = (array1, array2) => {
  const array2Sorted = array2.slice().sort();
  return (
    array1.length === array2.length &&
    array1
      .slice()
      .sort()
      .every(function (value, index) {
        return value === array2Sorted[index];
      })
  );
};
export const capitalize = (word) => {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
};

// Locale 'es-AR' helps formatting $1000 to $1.000,00
export const numberFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  currencyDisplay: 'symbol',
});

export const getValueOrDefault = {
  get: (target, name) =>
    Object.prototype.hasOwnProperty.call(target, name)
      ? isObject(target[name])
        ? new Proxy(target[name], getValueOrDefault)
        : target[name]
      : Object.prototype.hasOwnProperty.call(target, 'default')
      ? target.default
      : /\W/gm.test(name)
      ? name
      : !isNaN(parseInt(name, 10))
      ? parseInt(name, 10)
      : name,
};
